export default [
    {
        name: 'Contratações',
        url: '/credenciados/gestores/contratacoes',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        },
        regras: 'CRED-GEST-CONT-00'
    },
    {
        name: 'Entregas',
        url: '/credenciados/gestores/entregas',
        icon: 'fa fa-truck',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        },
        regras: 'CRED-GEST-ENTR-00'
    },
    {
        name: 'Aditivos',
        url: '/credenciados/gestores/solicitacoesaditivos',
        icon: 'fa fa-plus-circle',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        },
        regras: 'CRED-GEST-ADIT-00'
    },
    {
        name: 'Reaberturas de Entregas',
        url: '/credenciados/gestores/solicitacoesreaberturas',
        icon: 'fa fa-refresh',
        regras: 'CRED-GEST-ENTR-06'
    },
    {
        name: 'Paineis',
        url: '/credenciados/gestores/paineis',
        icon: 'fa fa-file',
        regras: ['CRED-GEST-PNL-00'],
        children: [
            {
                name: 'Comprom. com Erro',
                url: '/credenciados/gestores/paineis/erroscomprometimentos',
                icon: 'fa fa-exclamation-circle',
                regras: 'CRED-GEST-PNL-01'
            }
        ]
    }
]
